import $ from 'jquery';
import run from '../../utilities/run';
import {bindJumpToWizardLinks} from '../../utilities/jumpToWizardLogic';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run("#collateral-details-page", ()=>{
  const collateralDetailsPage = $("#collateral-details-page");
  const activateBtn = ".activate";
  const inactivateBtn = ".delete";
  const activateUrl = collateralDetailsPage.data("activate-url");
  const inactivateUrl = collateralDetailsPage.data("inactivate-url");
  const pageRefreshUrl = collateralDetailsPage.data("page-refresh-url");
  const collateralRules = collateralDetailsPage.data("collateral-rules");
  const collateralDetailItmRules = collateralDetailsPage.data("collateral-detail-itm-rule-mapping"); 
  const collateralRuleConditionsUrl = collateralDetailsPage.data("get-collateral-rule-conditions"); 
  const namespace = collateralDetailsPage.data("namespace");
  const activateModalTitleTxt = collateralDetailsPage.data("activate-modal-title-txt");
  const activateModalBodyTxt = collateralDetailsPage.data("activate-modal-body-txt");
  const activateModalBtnTxt = collateralDetailsPage.data("activate-modal-btn-txt");
  const inactivateModalTitelTxt = collateralDetailsPage.data("inactivate-modal-title-txt");
  const inactivateModalBodyTxt = collateralDetailsPage.data("inactivate-modal-body-txt");
  const inactivateModalBtnTxt = collateralDetailsPage.data("inactivate-modal-btn-txt");

  bindJumpToWizardLinks();

  $(activateBtn).click(function(e) {
    e.preventDefault();
    updateItem(activateModalTitleTxt, activateModalBodyTxt, activateModalBtnTxt, activateUrl);
  });

  $(inactivateBtn).click(function(e) {
    e.preventDefault();
    updateItem(inactivateModalTitelTxt, inactivateModalBodyTxt, inactivateModalBtnTxt, inactivateUrl);
  });

  function updateItem(title, body, btn, url) {
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: title,
      confirmModalBody: `<div class="q-pad-all-xl">${body}</div>`,
      confirmModalBtnText: btn,
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        $.ajax({ 
          url: url,
          success: function(data) { 
            if (data.match("success")) {
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = pageRefreshUrl;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            } else {
              submitModalFlow.showFailureModal();
            }
          },
          error: function() {
            submitModalFlow.hideAllModals();
          }
        }); 
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

  function checkForRules(){
    if(collateralDetailItmRules === null || collateralDetailItmRules.length == 0)
    {
      $(".no-rules-well").show();
      $(".collateral-details-rules-tab-rules-alert").hide();
    }
    else
    { 
      $(".no-rules-well").hide();
      $(".no-rules-div").hide();
      $.each(collateralDetailItmRules, function(key, value){
       $("#qtyPerRule-"+value.clrCbrId).text(value.clrQtyPerRule);
     });
      $(".collateral-details-rules-tab-rules-alert").show();
    }
  }

  $('#collateral-details-rules-table-id').dataTable({
    data: collateralRules,
    "bPaginate": false,
    "bSearchable": false,
    "bInfo": false,
    "bFilter": false,
    "bSortable": false,
    columns: [
    { data: "cbrId", "orderable": false,"searchable": false, "bSortable": false,
    render: function ( data, type, row ) {
     if ( type === 'display' ) {
      let html = '<div class="checkbox checkbox-success cb-large collateralRulesCheckbox disabled">' +
      '<input type="checkbox" disabled readonly checked id="cbrId-' + row.cbrId + '" value="' + row.cbrId + '" name="collateralRules" class="collateralRulesLookup"/>' +
      '<label for="cbrId-' + row.cbrId + '"></label>' +
      '</div>';
      return html;
    }
    return data;
  },
  className: "select-checkbox", width: "45px"},
  { data: "cbrName", "orderable": false,"searchable": false, "bSortable": false,"class":"details-control first-element-containing-data" , width: "126px"},
  { data: "cbrDescription","orderable": false, "searchable": false,"class":"details-control second-element-containing-data"},
  { data: "cbrId","orderable": false, "searchable": false, "class":"details-control rule-number",
  render: function ( data, type, row ) {
   if ( type === 'display' ) {
    let html = '<div id="qtyPerRule-' + row.cbrId + '" class="third-element-containing-data""></div>';
    return html;
  }
  return data;
}
},
{ data: "cbrId", "orderable": false,"searchable": false,
render: function ( data, type, row ) {
 if ( type === 'display' ) {
  let html = '<div class="rule-details fourth-element-containing-data">' +
  '<a href="#" class="rule-details-link" id="' + row.cbrId + '" name="cbrIdDetailsLink" value="' + row.cbrId + '">' +
  '<i class="fa fa-eye" aria-hidden="true"></i> View Rule Details' +
  '</a></div>';
  return html;
}
return data;
}
}
],
"initComplete": function() {
  checkForRules();
}
});

  $(document).on("click", ".rule-details-link", function(e){
   e.preventDefault();
   let businessRuleId = this.id;
   getBusinessRuleConitions({data: businessRuleId, success: findCollateralRuleConditionSucess, error: findCollateralRuleConditionError});

 });

  function getBusinessRuleConitions({data, success, error}){

    $.ajax({
      data: {
        [`${namespace}cbrId`]: data
      },
      url: collateralRuleConditionsUrl,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function findCollateralRuleConditionSucess(response)
  {
      //const rule = JSON.stringify(response);
      $("#rule-effective-dates").html("Effective from "+ timestampToDate(response.cbrEffectiveStartDate) + " until " + timestampToDate(response.cbrEffectiveEndDate) );
      $("#rule-conditions-and-params").html(response.displayCmrRuleConditions);
      $("#collateral-detail-rules-modal").modal("show");
    }

    function findCollateralRuleConditionError()
    {

    }

    function timestampToDate(createdDate)
    {
      let date = new Date(createdDate); //createdDate is long time format
      let month = date.getMonth() + 1;
      return (month > 9 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
    }

  });


// WEBPACK FOOTER //
// ./src/pages/products/collateralDetailsPage.js